module.exports = __webpack_public_path__ + "static/media/SEA-101-badge.61f6cedf.svg";